/* import __COLOCATED_TEMPLATE__ from './folder-balances.hbs'; */
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { Currency, Money } from '@square/dashboard-protos/models/squareup/connect/v2/common/money';
import { AccountScopedIdentifier } from '@square/dashboard-protos/models/squareup/bbfrontend/common/identifier/account_scoped_identifier';
import { AccountState } from '@square/dashboard-protos/models/squareup/banking/common';
import { Action, getEvent, MerchantType, Target, Page } from '@banking/ui/utils/folder-cdp-events';
let FolderBalances = (_dec = service('bbfrontend/v1/withholding-config'), _dec2 = service('bbfrontend/v1/account'), _class = class FolderBalances extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "capitalEngineContext", _descriptor, this);
    _initializerDefineProperty(this, "automationSubaccountState", _descriptor2, this);
    _initializerDefineProperty(this, "foldersAccounts", _descriptor3, this);
    _initializerDefineProperty(this, "bbFrontendV1WithholdingConfigService", _descriptor4, this);
    _initializerDefineProperty(this, "bbFrontendV1AccountService", _descriptor5, this);
    _initializerDefineProperty(this, "dataApi", _descriptor6, this);
    _defineProperty(this, "emptyBalance", Money.create({
      amount: 0,
      currency: Currency.CAD
    }));
  }
  get hasFolderBalance() {
    return Boolean(this.args.balances?.length);
  }
  async refreshAccounts() {
    const accounts = await this.bbFrontendV1AccountService.listAccounts([AccountScopedIdentifier.create({
      type: AccountScopedIdentifier.TokenType.TOKEN_TYPE_MERCHANT,
      token: this.capitalEngineContext.sessionContext.merchantToken
    })]);
    const accountIds = accounts.filter(a => a.state !== AccountState.CLOSED).map(account => account.id);
    await this.bbFrontendV1WithholdingConfigService.list(accountIds);
  }
  openCreateSubaccountFlow(event) {
    const {
      name,
      properties
    } = getEvent(Action.Click, {
      page: Page.SavingsHomepage,
      target: Target.GetStarted,
      merchantType: this.automationSubaccountState.activeUnits.length > 1 ? MerchantType.MultiUnit : MerchantType.SingleUnit
    });
    this.dataApi.track(name, properties);
    this.args.onOpenCreateFolderFlow();
    event?.target?.deselect();
  }
  closeCreateSubaccountFlow() {
    this.args.onCloseCreateFolderFlow();
    this.automationSubaccountState.resetValues();
  }
  get hasNeverHadFolders() {
    return !this.args.hasDeactivatedAllFoldersAccounts && !this.hasFolderBalance;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "capitalEngineContext", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "automationSubaccountState", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "foldersAccounts", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "bbFrontendV1WithholdingConfigService", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "bbFrontendV1AccountService", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "dataApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "refreshAccounts", [action], Object.getOwnPropertyDescriptor(_class.prototype, "refreshAccounts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openCreateSubaccountFlow", [action], Object.getOwnPropertyDescriptor(_class.prototype, "openCreateSubaccountFlow"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeCreateSubaccountFlow", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closeCreateSubaccountFlow"), _class.prototype), _class);
export { FolderBalances as default };